export default "__VITE_ASSET__DGQenq0d__"